import store from '@/desktop/stores'

//保障重新計算
export const recalculateCoverage = function(userId, plcno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            PLCNO: plcno
        }
    };
    return body;
};

//保障重新計算
export const recalculateCoverageGroup = function(userId, plcno, csidno) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            PLCNO: plcno,
            CSIDNO: csidno
        }
    };
    return body;
};

//查詢Excel資料
export const getExcelData = function(userId, category) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            code_category: category
        }
    }
    return body
}

//下載Excel
export const getExcel = function(userId, sendData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: sendData
    }
    return body
}

//商品設定-保障分類設定-查詢目前存檔的使用者
export const querySaveId = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            code: reqData
        }
    };
    return body;
};

//商品設定-保障分類設定-查詢保障中分類、查詢該中分類代碼最大的數字
export const queryMidCategory = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            code_category: reqData
        }
    };
    return body;
};

//商品設定-保障分類設定-新增保障群組中分類
export const insertMidCategory = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            code_category: reqData.code_category,
            code: reqData.code,
            code_name: reqData.code_name,
            modification_type: reqData.modification_type,
            modification_reason: reqData.modification_reason,
            memo: reqData.memo,
            status: reqData.status,
            creator: reqData.creator,
            creatorname: reqData.creatorname,
        }
    };
    return body;
};

//商品設定-保障分類設定-查詢所有保障細項、查詢尚未加入群組的細項
export const querySmallCategoryAll = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {       
        }
    };
    return body;
};

//商品設定-保障分類設定-查詢已加入群組保障細項、查詢已加入群組保障細項_未覆核、查詢要移除群組保障細項_未覆核、查詢異動紀錄
export const querySmallCategoryByCode = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            code: reqData
        }
    };
    return body;
};

//商品設定-保障分類設定-異動保障中項
export const insertDTMVZ006MID = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-保障分類設定-異動保障細項
export const insertDTMVZ006 = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-保障分類設定-執行覆核
export const doCheckCategory = function(userId, code) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            checkuser: userId,
            code: code
        }
    };
    return body;
};

//商品設定-查詢保障項目
export const getCoverageItemDetailByName = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            name: reqData.itemName,
        }
    };
    return body;
};

//商品設定-查詢保障設定檔
export const getReportSettings = function(userId, type) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            type: type,
        }
    };
    return body;
};

//商品設定-新增保障設定
export const insertReport = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: reqData.report,
            report_name: reqData.report_name,
            shell: reqData.shell,
            shell_level: reqData.shell_level,
            sum_position: reqData.sum_position,
            memo: reqData.memo,
            status: reqData.status,
            creator: reqData.creator,
            creatorname: reqData.creatorname,
        }
    };
    return body;
};

//商品設定-更新保障設定
export const updateReport = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-儲存保障設定
export const saveReport = function(userId, report) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            report: report,
        }
    };
    return body;
};

//商品設定-查詢保障設定列表
export const getReportList = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {}
    };
    return body;
};

//商品設定-搜尋保障設定
export const searchReport = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-查詢特殊條件列表
export const getSpecialConditionsList = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {}
    };
    return body;
};

//商品設定-新增特殊條件
export const insertSpecialCondition = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-查詢特殊條件
export const getSpecialConditionDetail = function(userId, code) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            code: code
        }
    };
    return body;
};

//商品設定-查詢特殊條件編輯頁選項
export const getSpecialConditionDetailFormOptions = function(userId, company, product) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            companyid: company,
            product: product,
        }
    };
    return body;
};

//商品設定-查詢特殊條件編輯頁公司別下拉選項
export const getCompanyOptions = function(userId) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {}
    };
    return body;
};

//商品設定-查詢特殊條件編輯頁險種下拉選項
export const getProductOptions = function(userId, company) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            companyid: company,
        }
    };
    return body;
};

//商品設定-更新保障設定
export const updateSpecialCondition = function(userId, reqData) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: reqData
    };
    return body;
};

//商品設定-儲存保障設定
export const saveSpecialCondition = function(userId, code) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            code: code,
        }
    };
    return body;
};

// 判斷傳入單位代碼是否有在權限版控裡
export const checkUnitExist = function(userId, unitCode) {
    let body = {
        header: {
            userDeviceIp: store.state.userIP,
            userId: userId
        },
        body: {
            unitCode: unitCode
        }
    };
    return body;
};